import { render, staticRenderFns } from "./steps.component.vue?vue&type=template&id=4fe1fb04&scoped=true&lang=pug"
import script from "./steps.component.vue?vue&type=script&lang=ts"
export * from "./steps.component.vue?vue&type=script&lang=ts"
import style0 from "./steps.component.vue?vue&type=style&index=0&id=4fe1fb04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe1fb04",
  null
  
)

export default component.exports